import Vue from 'vue';
import store from './../../store';

const success = (context, response) => {
  toastr.success(context.$t('account.update_success'));
  store.dispatch('updateAccount', response.user);
};

const failed = (context, error) => {
  context.showToasterError(error);
};

export default (context, data, userId) => Vue.$http.post(`vrbo/update-default-lodging-config/${userId}`, data)
    .then((response) => {
      if (response && response.status === 200) {
        success(context, response);
      }
    }).catch((error) => {
      failed(context, error);
    });



// WEBPACK FOOTER //
// ./src/app/services/vrbo/vrboUpdateDefaultLodgingConfig.js